'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var aviaryTokens = require('aviary-tokens');
var Status_web_styles = require('./Status.web.styles.cjs');

/**
 * Status component is used to display a status message with a colored dot
 *
 * {@link https://aviary.supernova-docs.io/latest/components/status/overview-kbqEHX1X | Documentation}
 *
 * @scope Core
 */ const Status = ({ intention, size = "medium", children, customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const themeColors = aviaryTokens.colorProfileMapper(currentTheme);
    const statusStyles = [
        Status_web_styles.status,
        Status_web_styles.intention(themeColors[intention]),
        Status_web_styles.size[size],
        customCss
    ];
    const dotStyles = Status_web_styles.profileStyles(themeColors[intention]);
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: statusStyles,
        "data-testid": "status-wrapper",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("span", {
                css: dotStyles,
                "data-testid": "dot"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("span", {
                children: children
            })
        ]
    });
};
Status.displayName = "Status";

exports.Status = Status;
//# sourceMappingURL=Status.web.cjs.map
